import { Container } from 'react-bootstrap';
import PublicRoomLander from 'components/views/PublicRoom/_components/PublicRoomLander';
import PublicRoomCompanySnapshot from 'components/views/PublicRoom/_components/PublicRoomCompanySnapshot';
import useEffectAsync from 'utils/useEffectAsync';
import { fetchAndSetPublicDealData } from 'components/views/PublicRoom/_helpers/publicRoom.resolvers';
import { useParams } from 'react-router-dom';
import PublicRoomTerms from 'components/views/PublicRoom/_components/PublicRoomTerms';
import PublicRoomTeam from 'components/views/PublicRoom/_components/PublicRoomTeam';
import PublicRoomAddToPipelineModal from 'components/views/PublicRoom/_components/PublicRoomAddToPipelineModal';
import PublicRoomVault from 'components/views/PublicRoom/_components/PublicRoomVault';
import { $detail, $view } from 'signals/global.signals';
import { getPublicRoomAnimationStyle } from 'components/views/PublicRoom/_helpers/publicRoom.utils';
import React, { useEffect } from 'react';
const PublicRoom = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const tab = searchParams.get('tab');
  const { id } = useParams();

  useEffectAsync(async () => {
    $view.update({
      ...$view.value,
      activeTab: tab,
    });
    await fetchAndSetPublicDealData({ id });
  }, [tab]);
  return (
    <Container fluid className="vh-100 p-0 m-0">
      {($view.value.activeTab === 'lander' || !$view.value.activeTab || $view.value.userHasAccessToDeal) && <PublicRoomLander />}
      {$view.value.activeTab === 'company-snapshot' && (
        <div style={getPublicRoomAnimationStyle($view.value.isShowFadeIn)}>
          <PublicRoomCompanySnapshot />
        </div>
      )}
      {$view.value.activeTab === 'deal-terms' && $detail.value.userHasAccessToDeal && <PublicRoomTerms />}
      {$view.value.activeTab === 'team' && $detail.value.userHasAccessToDeal && <PublicRoomTeam />}
      {$view.value.activeTab === 'data-room' && $detail.value.userHasAccessToDeal && <PublicRoomVault />}
      <PublicRoomAddToPipelineModal dealId={id} />
    </Container>
  );
};

export default PublicRoom;
